import { render, staticRenderFns } from "./ques91.vue?vue&type=template&id=0051f060&scoped=true"
import script from "./ques91.vue?vue&type=script&lang=js"
export * from "./ques91.vue?vue&type=script&lang=js"
import style0 from "./ques91.vue?vue&type=style&index=0&id=0051f060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0051f060",
  null
  
)

export default component.exports